import { format, parseISO } from "date-fns";
import {
  MDBBtn,
  MDBDatatable,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router";
import Header from "../components/Header";
import LeftPane from "../components/LeftPane";
import {
  DBActivMembers,
  DBCheckins,
  DBExpirymemArray,
  DBMembershipRenewal,
  DBPayment,
  DBStaffattendance,
  getGymAddonsList,
  getPlans,
  DBOverdueCheckins,
  DBInactiveActiveMembers
} from "../services/apiServices.js";
import payRImg from "./../components/images/Payments-received.svg";
import calImg from "./../components/images/calendar.svg";
import greenImg from "./../components/images/green.svg";
import payPImg from "./../components/images/payments-pending.svg";
import redcImg from "./../components/images/red-c.svg";
import stdwnImg from "./../components/images/stats-down.svg";
import stupImg from "./../components/images/stats-up.svg";
import ucheckInImg from "./../components/images/user-checkin.svg";
import usrImg from "./../components/images/users.svg";
import PageError from "./PageError";
import { isMobile } from "react-device-detect";
import { formatDate, formatDateTimeWithTZ } from '../utils/DateFormat';
import ExcelExportButton from "../components/exportToExcel";
import { BasePlanName, resolvePlanAndSubplan } from "../utils/BasePlanName";
import { useAccess } from "../context/AccessContext";

export default function Dashboard() {

  const [apiError, setApiError] = useState(false);
  const [basicActive, setBasicActive] = useState("tab1");
  // const [addons, setAddons] = useState([]);
  const [plans, setPlans] = useState([]);
  const [overdueFilter, setOverdueFilter] = useState({})
  const [overduePopup, setOverduePopup] = useState(false)
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };
  const navigate = useNavigate();
  const { loading, handlePageAccess, fetchAccess } = useAccess();
  const roleAccess = handlePageAccess("dashboard")
  const [sFlag, setFlag] = useState(0);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [expiryData, setExpiryData] = useState([])
  const [startDate, endDate] = dateRange;
  const [cusomck, setCusomck] = useState(false);
  const [checked, setChecked] = useState((localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin" ? "Month" : "Today");
  const [StaffAtt, setStaffAtt] = useState("");
  const [MemRenew, setMemRenew] = useState("");

  const [Checkin, setCheckin] = useState("");
  const [ActMem, setActMem] = useState("");
  const [Payment, setPayment] = useState("");
  let gymid = null;



  const [inactiveMembers, setInactiveMembers] = useState();
  const [inactiveMemberinfo, setInactiveMemberinfo] = useState([]);
  console.log("inactiveMemberinfo", inactiveMemberinfo);
  const [inactivePopup, setInactivePopup] = useState(false);
  const [inactiveFilter, setInactiveFilter] = useState({});
  const [inactiveLoading, setInactiveLoading] = useState(false);

  const [inactiveDaysFilter, setInactiveDaysFilter] = useState(10);


  try {
    gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
  } catch (e) {
    localStorage.removeItem("token");
    localStorage.removeItem("loggedUserInfo");
    window.location.href = "/login";

  }

  function getDateRange(value) {
    setDateRange(value);
    if (value && value.length === 2 && value[1] !== null) {
      let fdate = getRDateTime(value[0]).date;
      let tdate = getRDateTime(value[1]).date;
      console.log(fdate + ", " + tdate);
      fetchData(fdate, tdate, "Custom");
    }
  }



  function getRDateTime(tdbtime) {
    var now = new Date(tdbtime);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();
    var second = now.getSeconds();
    if (month.toString().length === 1) {
      month = "0" + month;
    }
    if (day.toString().length === 1) {
      day = "0" + day;
    }
    if (hour.toString().length === 1) {
      hour = "0" + hour;
    }
    if (minute.toString().length === 1) {
      minute = "0" + minute;
    }
    if (second.toString().length === 1) {
      second = "0" + second;
    }
    var dateTime = {
      date: year + "-" + month + "-" + day,
      time: hour + ":" + minute,
    };
    return dateTime;
  }

  const CalenderInput = forwardRef(({ value, onClick }, ref) => (
    <>
      <span className="gym-input forminput " onClick={onClick}>
        {value === "" ? "Custom Range" : value}
        &nbsp;
        <img src={calImg} alt="Custom Range" ref={ref} title="Select Custom Range" />
      </span>
    </>
  ));

  console.log(roleAccess?.dashboard?.access);

  // useEffect(() => {
  //   const handlenavigation = async () => {
  //     await fetchAccess()
  //     if (roleAccess) {
  //       console.log(roleAccess?.dashboard?.access, '  console.log(roleAccess?.dashboard?.access);');
  //       if ((roleAccess?.dashboard?.access) == false) {
  //         navigate("/mmanager")
  //       }
  //     }
  //   }
  //   handlenavigation()
  // }, [])

  function fetchData(fDay, lDay, dayfilter) {


    setDateRange([new Date(fDay), new Date(lDay)])
    let firstoftheday = new Date(fDay);
    firstoftheday.setHours(0, 0, 0, 0);
    const firstDay = firstoftheday.toISOString();
    let lastoftheday = new Date(lDay);
    lastoftheday.setHours(23, 59, 59, 999);
    const lastDay = lastoftheday.toISOString();
    console.log(firstDay, lastDay, '6lastDay');

    ChangingData();
    paymentFunction(firstDay, lastDay, dayfilter);
    OverDueCheckins(firstDay, lastDay, dayfilter)
    activememberFunction(firstDay, lastDay);

    StaffattendanceFunction(firstDay, lastDay);
    memberRenewalFunction(firstDay, lastDay);

    checkinsFunction(firstDay, lastDay);
  }

  function ChangingData() {
    setStaffAtt("");

    setMemRenew("");

    setCheckin("");
    setActMem("");
    setPayment("");
  }
  //****************************************************************************** */
  function handleTodayClick(id) {
    setCusomck(false);
    setChecked(id);
    const currentTime = new Date();
    const startOfToday = new Date(currentTime);
    //startOfToday.setHours(0, 0, 0, 0);

    const endOfToday = new Date(currentTime);
    //endOfToday.setHours(23, 59, 59, 999);
    fetchData(startOfToday, endOfToday, id);
  }

  function handleYesterdayClick(id) {
    setChecked(id);
    setCusomck(false);
    const currentTime = new Date();
    const yesterday = new Date(currentTime);
    yesterday.setDate(currentTime.getDate() - 1);
    const startOfYesterday = new Date(yesterday);
    //startOfYesterday.setHours(0, 0, 0, 0);
    const endOfYesterday = new Date(yesterday);
    //endOfYesterday.setHours(23, 59, 59, 999);
    fetchData(startOfYesterday, endOfYesterday, id);
  }

  function handleThisWeekClick(id) {
    setChecked(id);
    setCusomck(false);
    const currentTime = new Date();
    const startOfWeek = new Date(currentTime);
    startOfWeek.setDate(currentTime.getDate() - currentTime.getDay());
    // startOfWeek.setHours(12, 0, 0, 0);

    const endOfWeek = new Date(currentTime);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    // endOfWeek.setHours(12, 0, 0, 0);
    fetchData(startOfWeek, endOfWeek, id);
  }

  function handleThisMonthClick(id) {
    setChecked(id);
    setCusomck(false);
    const currentTime = new Date();
    const startOfMonth = new Date(currentTime);
    startOfMonth.setDate(1);
    //startOfMonth.setHours(0, 0, 0, 0);

    const endOfMonth = new Date(currentTime);
    endOfMonth.setMonth(currentTime.getMonth() + 1, 0);
    //endOfMonth.setHours(23, 59, 59, 999);
    fetchData(startOfMonth, endOfMonth, id);
  }

  function handleThisCustomClick(id) {
    setChecked(id);
    setCusomck(true);
  }
  const [allPlans, setAllPlans] = useState([])
  async function fetchPData() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getPlans(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {
        const plans = await response.json();
        console.log("plans", plans)


        const allPlans =
          plans && plans.length > 0
            ? plans.flatMap(plan => {
              // map subplans like normal plans
              const subplans =
                plan.subplans?.map(sub => ({
                  ...sub,
                  baseplan: plan._id,
                  // baseplanName: plan.name,
                  isSubplan: true,
                })) || [];

              return [plan, ...subplans];
            })
            : [];

        // Apply filter for both plans & subplans
        // console.log(plans);
        setAllPlans(plans)
        const filterPlans = plans && plans.length > 0 ? plans.filter(item => item.ptype !== 1) : [];
        console.log(filterPlans);

        setPlans(allPlans);
      }
    }
  }

  async function fetchAddons() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getGymAddonsList(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
      } else {
        const data = await response.json()
        // setAddons(data);
        console.log("Info set..", data);
      }
    }
  }
  /*********************by vamshi************************************** */

  useEffect(() => {
    // expiryarrayFunction()
    // fetchAddons();
    fetchPData();

    let todaydate = new Date();

    var firstDay = new Date(todaydate);
    firstDay.setDate(1);
    firstDay.setHours(12, 0, 0, 0);
    var lastDay = new Date(todaydate);
    lastDay.setMonth(todaydate.getMonth() + 1, 0);

    if ((localStorage.getItem("loggedUserInfo")) && JSON.parse(localStorage.getItem("loggedUserInfo")).role === "admin") {
      setDateRange([firstDay, lastDay]);
      fetchData(firstDay, lastDay, "Month");
    } else {
      const currentTime = new Date();
      const startOfToday = new Date(currentTime);
      const endOfToday = new Date(currentTime);
      fetchData(startOfToday, endOfToday, "Today");

    }
    InactiveActiveMembers(10);


  }, [sFlag]);

  async function StaffattendanceFunction(firstDay, lastDay) {
    const response = await DBStaffattendance(gymid, {
      fdate: firstDay,
      tdate: lastDay,
      today: new Date()
    });
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      setStaffAtt(recinfo);
      console.log(recinfo);
    }
  }
  async function memberRenewalFunction(firstDay, lastDay) {
    const response = await DBMembershipRenewal(gymid, {
      fdate: firstDay,
      tdate: lastDay,
      today: new Date()
    });
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      console.log(recinfo);
      setMemRenew(recinfo);
    }
  }

  const [overDuecheckins, setOverDuecheckins] = useState()

  const OverDueCheckins = async (firstDay, lastDay, checked) => {
    const Dayfilter = checked == "Today" ? 1 : (checked == "Yesterday" ? 2 : (checked == "Week" ? 3 : (checked == "Month" ? 4 : 6)))
    const update = {
      fdate: firstDay,
      tdate: lastDay,
      Dayfilter
    }
    const response = await DBOverdueCheckins(JSON.parse(localStorage.getItem("loggedUserInfo")).gymid, update)
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      console.log(recinfo, '666666666666666666666666666666666666666666666666')
      // setCheckin(recinfo);
      setOverDuecheckins(recinfo);
    }
  }

  async function checkinsFunction(firstDay, lastDay) {
    const response = await DBCheckins(gymid, {
      fdate: firstDay,
      tdate: lastDay,
      today: new Date()
    });
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      console.log(recinfo)
      setCheckin(recinfo);
    }
  }

  async function activememberFunction(firstDay, lastDay) {
    const response = await DBActivMembers(gymid, {
      fdate: firstDay,
      tdate: lastDay,
      today: new Date()
    });
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      console.log(recinfo);
      setActMem(recinfo);
    }
  }

  // Update InactiveActiveMembers function with loading state
  const InactiveActiveMembers = async (days) => {
    setInactiveLoading(true);
    setInactiveMemberinfo([]);

    const update = {
      inactiveDays: days
    };


    const response = await DBInactiveActiveMembers(
      JSON.parse(localStorage.getItem("loggedUserInfo")).gymid,
      update
    );

    if (!response) {
      setInactiveLoading(false);
      return;
    }

    if (response === "false") {
      setApiError(true);
      setInactiveLoading(false);
    } else {
      const recinfo = await response.json();
      console.log("Received inactive members:", recinfo);
      setInactiveMembers(recinfo);
      setInactiveLoading(false);
    }
  };




  // Update handleInactiveDaysChange to check if popup is open:
  const handleInactiveDaysChange = (newDays) => {
    setInactiveDaysFilter(newDays);

    // Clear the popup data to prevent showing stale data
    setInactiveMemberinfo([]);

    // Re-fetch data with new filter (no date range needed)
    InactiveActiveMembers(newDays);
  };

  useEffect(() => {
    if (inactivePopup && inactiveMembers?.membersinfo) {
      let filteredInactive = [...inactiveMembers.membersinfo];

      if (inactiveFilter.data === 2) {
        filteredInactive = filteredInactive.filter((item) => item.sex === "Female");
      } else if (inactiveFilter.data === 1) {
        filteredInactive = filteredInactive.filter((item) => item.sex !== "Female");
      }

      setInactiveMemberinfo(filteredInactive);
    }
  }, [inactiveMembers, inactivePopup]);

  const ViewInactiveHandler = (event, page, tInfo) => {

    // Set filter without date fields (they're not needed anymore)
    setInactiveFilter({
      ...tInfo,
      inactiveDays: inactiveDaysFilter
    });

    // Create a fresh copy of the members info
    let filteredInactive = inactiveMembers?.membersinfo ? [...inactiveMembers.membersinfo] : [];

    // Apply gender filtering
    if (tInfo.data == 2) {
      filteredInactive = filteredInactive.filter((item) => item.sex === "Female");
    } else if (tInfo.data == 1) {
      filteredInactive = filteredInactive.filter((item) => item.sex !== "Female");
    }

    setInactiveMemberinfo(filteredInactive);
    setInactivePopup(true);
  };


  // 2. Update useEffect dependencies to include allPlans and addons:
  useEffect(() => {
    const popupRow = [];
    let snumber = 1;

    inactiveMemberinfo &&
      inactiveMemberinfo?.length > 0 &&
      inactiveMemberinfo?.forEach((item, index) => {
        const rarray = [];

        let planName = "--";

        // Try matching via planid against allPlans
        if (item.planid && allPlans.some(p => String(p._id) === String(item.planid))) {
          const plan = allPlans.find(p => String(p._id) === String(item.planid));
          planName = plan.name;
        } else if (item.plans && item.plans.length > 0) {
          // Fallback: use the most recent plan directly from MemberView
          planName = item.plans[0].name || "--";
        }

        // Balance sessions from the member's session record
        const sessionValue = item.session?.balsessions != null ? item.session.balsessions : "--";

        rarray.push(snumber++);
        rarray.push(item.fname ? item.fname + " " + item.lname : "--");
        rarray.push(item.number ? item.number : "--");
        rarray.push(planName);
        rarray.push(sessionValue);
        rarray.push(item?.expirydate ? formatDate(item.expirydate) : '--');
        rarray.push(item.lastCheckinDate ? formatDate(item.lastCheckinDate) : "Never");
        rarray.push(item.daysSinceLastCheckin ? item.daysSinceLastCheckin + " days" : "Never visited");
        // rarray.push(
        //   <div className="title">
        //     {!item.issuspend ?
        //       item.mStatus ? item.mStatus :
        //         (new Date(item.expirydate) > new Date() ? "Active" : "Inactive")
        //       : "Suspended"}
        //   </div>
        // );
        // rarray.push(item?.expirydate ? formatDate(item.expirydate) : '--');

        popupRow.push(rarray);
      });

    setInactiveBasicData((prev) => ({ ...prev, rows: popupRow }));
  }, [inactiveMemberinfo, allPlans]);




  const [inactiveBasicData, setInactiveBasicData] = useState({
    columns: [
      "S.no",
      "Name",
      "Number",
      "Plan",
      "Balance Session(s)",
      "Expiry Date",
      "Last Check-In Date",
      "Days Since Last Visit",

    ],
    rows: [],
  });


  async function paymentFunction(firstDay, lastDay, checked) {
    const Dayfilter = checked == "Today" ? 1 : (checked == "Yesterday" ? 2 : (checked == "Week" ? 3 : (checked == "Month" ? 4 : 6)))
    const response = await DBPayment(gymid, {
      fdate: firstDay,
      tdate: lastDay,
      dayfilter: Dayfilter
    });
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      setPayment(recinfo);
      console.log(recinfo);
    }
  }

  useEffect(() => {
    fetchExpiryData()
  }, [])

  async function fetchExpiryData() {
    const response = await DBExpirymemArray(gymid);
    // console.log("huwidgucddfgeh", response);
    if (!response) {
      return;
    }
    if (response === "false") {
      setApiError(true)
    } else {
      const recinfo = await response.json();
      console.log(recinfo);
      setExpiryData(recinfo)

      // const response1 = await getPlans(
      //   localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : ""
      // );
      // if (!response1) {
      //   return;
      // }
      // if (response1 === "false") {
      //   setApiError(true)
      //   return;
      // }
      // const plans = await response1.json()


      // const filterPlans = plans && plans.length > 0 ? plans.filter(item => item.ptype !== 1) : [];
      // console.log(filterPlans);
      // console.log("22222filterPlans", filterPlans)


      // setPlans(filterPlans);
      // const response2 = await getGymAddonsList(
      //   localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : ""
      // );
      // if (!response2) {
      //   return;
      // }
      // if (response2 === "false") {
      //   setApiError(true)
      //   return;
      // }
      // setAddons(await response2.json())

    }
  }


  function handleClik(data) {

    let selMember = data
    selMember._id = data._id;
    selMember.return = "dashboard"

    console.log(selMember);
    navigate("/mdetails", {
      state: selMember,
    });

  }


  let overdmem = [];

  let exdmem = [];

  let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;


  expiryData && expiryData.length > 0 && expiryData.forEach((data, index) => {
    let rarray = [];

    let filteredplandata;

    // 1. Try matching base plan first
    filteredplandata = plans.find(plan => String(plan._id) === String(data.planid));

    // // 2. If not found, try matching subplan
    // if (!filteredplandata) {
    //   let parentPlan, subplan;

    //   for (const plan of plans) {
    //     subplan = plan.subplans?.find(sp => String(sp._id) === String(data.planid));
    //     if (subplan) {
    //       parentPlan = plan;
    //       break;
    //     }
    //   }

    //   if (parentPlan && subplan) {
    //     // Merge parent plan with the matching subplan
    //     filteredplandata = { ...parentPlan, selectedSubplan: subplan };
    //   }
    // }

    // const filteredaddondata = addons.length > 0 ? addons.find((item) => item._id === data.planid) : [];

    if (plansInfo != null && plansInfo?.feature?.planswithsessionslimit) {
      // Don't filter, use the original filteredplandata
    } else {
      // Filter out plans with sessioncheck set to true
      let filterPlans = plans.filter((obj) => !obj.sessioncheck);
      filteredplandata = filterPlans.find((item) => item._id === data.planid);
    }
    // console.log("filteredplandata", filteredplandata)
    if (!filteredplandata) return;


    let displayName = "--";
    if (filteredplandata?.baseplan) {

      // displayName = `${filteredplandata.name} - ${filteredplandata.selectedSubplan.name}`;

      const baseName = BasePlanName(plans, filteredplandata?.baseplan);
      displayName = `${baseName} - ${filteredplandata.name}`;




    } else if (filteredplandata?.name) {
      displayName = filteredplandata?.name;
    }

    let balanceSessions = "--";
    if (data?.sessions && data?.sessions?.balsessions !== undefined) {
      balanceSessions = data?.sessions?.balsessions;
    }


    // else if (filteredaddondata?.name) {
    //   displayName = filteredaddondata.name;
    // }

    // push values into row
    rarray.push(<div className="link-color" onClick={() => handleClik(data)}>{data.fname + " " + data.lname}</div>);
    rarray.push(displayName);
    rarray.push(data.number ? data.number : "--");
    rarray.push(data.sex ? data.sex : "--");
    rarray.push(data.age ? data.age : '--');
    rarray.push(balanceSessions)
    rarray.push(formatDate(data.expirydate));
    rarray.push(!data.issuspend &&
      <>
        <div
          className="ml0 link-color"
          onClick={() => {
            const membership = plans.find((p) => p._id === data.planid);
            const { planId, subplanId } = resolvePlanAndSubplan(membership, plans);
            preaddUser({
              member: data,
              planId,
              subplanId,
            });
          }}

        >
          Renew
        </div>
      </>
    );

    /**************************************************************************************************************/
    var week = new Date();
    week.setDate(week.getDate() + 6);
    const exp = new Date(data.expirydate);

    if (exp < new Date(week) && exp >= new Date()) {
      overdmem.push(rarray);
    }
    if (exp < new Date()) {
      exdmem.push(rarray);
    }
  });

  const mData = {
    columns: [
      "Name", "Plan", "Contact", "Gender", "Age", "Balance Sessions", "Expiring On", "Actions"
    ],
    rows: overdmem,
  };
  const mOData = {
    columns: [
      "Name", "Plan", "Contact", "Gender", "Age", "Balance Sessions", "Expired On", "Actions"
    ],
    rows: exdmem,
  };


  function preaddUser(dataObj) {
    console.log("984867preadduserdadhboard", dataObj)
    localStorage.setItem("preadd_plan", JSON.stringify(dataObj));
    localStorage.setItem("preadd_member", JSON.stringify(dataObj));
    localStorage.setItem("showPrevTransPopup", "true");
    navigate("/home");
  }

  const [overdueMemberinfo, setOverDueMemberinfo] = useState([])
  const [basicData, setBasicData] = useState({
    columns: [
      "S.no",
      "Name",
      "Number",
      "Plan",

      "Date",
      'Check-In',
      'Check-Out',
      // "Start Date",
      // "End Date",
      "Status",
      "Expiry Date"
    ],
    rows: [],
  });

  const ViewOverdueHandler = (event, page, tInfo) => {
    console.log(tInfo, 'tInfo');

    const Dayfilter = checked === "Today" ? "1" : (checked === "Yesterday" ? "2" : (checked === "Week" ? "3" : (checked === "Month" ? "4" : (checked === "Custom" ? "6" : "7"))));
    console.log({
      ...tInfo, fdate: new Date(startDate), tdate: new Date(endDate), Dayfilter: Dayfilter
    }, 'event, page, tInfo');
    setOverdueFilter({
      ...tInfo, fdate: new Date(startDate), tdate: new Date(endDate), Dayfilter: Dayfilter
    })

    let filteredOverdue = overDuecheckins?.membersinfo ? overDuecheckins?.membersinfo : []
    if (tInfo.data == 2) {
      filteredOverdue = overDuecheckins.membersinfo.filter((item) => item.member?.sex == "Female")
    } else if (tInfo.data == 1) {
      filteredOverdue = overDuecheckins.membersinfo.filter((item) => item.member?.sex !== "Female")
    }
    setOverDueMemberinfo(filteredOverdue)
    setOverduePopup(true)
  }
  console.log(overdueMemberinfo, 'overdueMemberinfo');

  useEffect(() => {
    const popupRow = [];
    let snumber = 1;
    overdueMemberinfo &&
      overdueMemberinfo?.length > 0 &&
      overdueMemberinfo?.forEach((item, index) => {
        const rarray = [];
        let Plandetails = [];
        let addondetails = [];
        if (allPlans.some((itm) => itm._id === item.planid)) {
          console.log(item.planid, allPlans.some((itm) => itm._id === item.planid), 'item.planid');
          Plandetails = allPlans.filter((itm) => itm._id === item.planid)
        }
        // else {
        //   addondetails = addons.filter((itm) => itm._id === item.planid)
        // }
        rarray.push(snumber++);

        rarray.push(item.member.fname ? item.member.fname + " " + item.member.lname : "--");
        rarray.push(item.member.number ? item.member.number : "--");
        // rarray.push(
        //   Plandetails.length > 0 ? Plandetails[0].name : (addondetails.length > 0 ? addondetails[0].name : "--")
        // );

        rarray.push(Plandetails.length > 0 ? Plandetails[0].name : "--");
        rarray.push(formatDate(item.intime || item.outtime));

        rarray.push(
          new Date(item.intime)
            .toLocaleTimeString("en-IN", {
              timeZone: "Asia/Kolkata",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })
        );

        rarray.push(
          (new Date(item.outtime)
            .toLocaleTimeString("en-IN", {
              timeZone: "Asia/Kolkata",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })) === "Invalid Date" ? "NA" : new Date(item.outtime)
              .toLocaleTimeString("en-IN", {
                timeZone: "Asia/Kolkata",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
        );
        rarray.push(item?.membershipstatus ? (item?.membershipstatus === "1" ? "Active" : "Inactive") : <div className="title">{!item.member.suspend ? item.member.mStatus ? item.member.mStatus : (new Date(item.member.expirydate) > new Date() ? "Active" : "Inactive") : "suspend"}</div>)

        rarray.push(item.member?.expirydate ? formatDate(item.member.expirydate) : '--');

        popupRow.push(rarray);
      });

    setBasicData((prev) => ({ ...prev, rows: popupRow }));

  }, [overdueMemberinfo]);

  const showInfo = (event, page, tInfo) => {
    const Dayfilter = checked === "Today" ? "1" : (checked === "Yesterday" ? "2" : (checked === "Week" ? "3" : (checked === "Month" ? "4" : (checked === "Custom" ? "6" : "7"))));
    if (event.ctrlKey || event.metaKey) {
      event.preventDefault();

      if (window.opener === null) {
        window.open(`/${page}`, "_blank");
      } else {
        navigate("/" + page, (page === "transactions" ? {

          state: {
            ...tInfo, fdate: new Date(startDate), tdate: new Date(endDate), Dayfilter: Dayfilter
          },
        } : {

          state: { ...tInfo, fdate: new Date(startDate), tdate: new Date(endDate) },
        }));
      }
    } else {
      navigate(`/${page}`);
      navigate("/" + page, (page === "transactions" ? {

        state: {
          ...tInfo, fdate: new Date(startDate), tdate: new Date(endDate), Dayfilter: Dayfilter
        },
      } : {

        state: { ...tInfo, fdate: new Date(startDate), tdate: new Date(endDate) },
      }));
    }
  };

  const handleReload = () => {
    window.location.reload();
  }

  const downloaddata = (data, title) => {
    ExcelExportButton(data, title);
  }

  useEffect(() => {
    handleFetchData();
  }, []);

  const handleFetchData = () => {
    if (roleAccess?.month !== 1) {
      if (roleAccess?.week == 1) {
        handleThisWeekClick("Week")
      } else if (roleAccess?.yesterday == 1) {
        handleYesterdayClick("Yesterday")
      } else if (roleAccess?.customrange == 1) {
        handleThisCustomClick("Custom")
      } else {
        handleTodayClick("Today")
      }
    }
  }
  return (
    <>
      <LeftPane isactive="11" />
      <Header />
      {apiError ? <PageError handleReload={handleReload} /> : <div className="gym-main gym-main-div rightContent pt-2">
        <div className="flex-grow-1 overflow-x-hidden overflow-x-auto ">
          <div className="gym-container gym-cnr" id="showcase">
            <h3 className="gym-large">Dashboard</h3>

            <div className="d-flex dashboard_links d-flex align-items-center">
              {roleAccess?.today == 1 && <button
                className={`p-0 me-5 button-link ${checked === "Today" ? "active" : ""}`}
                onClick={() => handleTodayClick("Today")}
              >
                Today
              </button>}
              {(localStorage.getItem("loggedUserInfo")) && roleAccess?.yesterday == 1 && <button
                className={`p-0 me-5 button-link ${checked === "Yesterday" ? "active" : ""}`}
                onClick={() => handleYesterdayClick("Yesterday")}
              >
                Yesterday
              </button>}
              {(localStorage.getItem("loggedUserInfo")) && roleAccess?.week == 1 && <button
                className={`p-0 me-5 button-link ${checked === "Week" ? "active" : ""}`}
                onClick={() => handleThisWeekClick("Week")}
              >
                {" "}
                This Week
              </button>}
              {(localStorage.getItem("loggedUserInfo")) && roleAccess?.month == 1 && <button
                className={`p-0 me-5 button-link ${checked === "Month" ? "active" : ""}`}
                onClick={() => handleThisMonthClick("Month")}
              >
                This Month
              </button>}
              {(localStorage.getItem("loggedUserInfo")) && roleAccess?.customrange == 1 && <span className="customRange align-items-center">
                <button
                  className={`p-0 me-5 custom button-link ${checked === "Custom" ? "active" : ""}`}
                  onClick={() => handleThisCustomClick("Custom")}
                >
                  Custom Range
                </button>
                {cusomck ? (
                  <div className="gym-xlarge gym-larg-pos">
                    <DatePicker
                      dateFormat={"d/M/yyyy"}
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        getDateRange(update);
                      }}
                      isClearable={false}
                      customInput={<CalenderInput />}
                    />
                  </div>
                ) : null}
              </span>}
            </div>
            <p className="pt-1 m-0 dashboard_note" style={{ color: '#8b8a8a' }}>
              <b>Note:</b> Above filters will show you the comparison of the data based
              on the selection. Ex: Week selection will show selected week and its
              previous last week data
            </p>
          </div>
          <div className={`row mt-10 ${isMobile ? "m-1" : ""}`} >


            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Today's Check-In's</h5>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main d-flex align-center text-bigger">
                          <button className="button-link link-color"
                            onClick={(e) => showInfo(e, "checkin", { data: 0 })}
                          >
                            {Checkin !== ""
                              ? Checkin.todaycheckin
                              : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>
                        <div className="card-text d-flex space-between">
                          <small>Male </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => showInfo(e, "checkin", { data: 1 })}
                            >
                              {Checkin !== ""
                                ? Checkin.mcount
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between">
                          <small>Female </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => showInfo(e, "checkin", { data: 2 })}
                            >
                              {Checkin !== ""
                                ? Checkin.fcount
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={ucheckInImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Active Members</h5>
                    <div className="d-flex align-items-center justify-content-center">
                      {ActMem === "" ? (
                        <Skeleton className="w-30px" />
                      ) : (
                        <>
                          <img
                            src={ActMem.upflag === "green" ? stupImg : stdwnImg}
                            alt="green"
                            className="me-2"
                          />
                          {ActMem.percent === "Infinity"
                            ? "100%"
                            : isNaN(ActMem.percent)
                              ? 0 + "%"
                              : ActMem.percent + "%"}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main d-flex align-center text-bigger">
                          <button className="button-link link-color"
                            onClick={(e) => showInfo(e, "mmanager", { data: 10 })}
                          >
                            {ActMem !== ""
                              ? ActMem.active
                              : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>
                        <div className="card-text d-flex space-between">
                          <small>Male </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) =>
                                showInfo(e, "mmanager", { data: 11 })
                              }
                            >
                              {ActMem !== ""
                                ? ActMem.mactive
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between">
                          <small>Female </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) =>
                                showInfo(e, "mmanager", { data: 12 })
                              }
                            >
                              {ActMem !== ""
                                ? ActMem.factive
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={usrImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Payment Received</h5>
                    <div className="d-flex align-items-center justify-content-center">
                      {Payment === "" ? (
                        <Skeleton className="w-30px" />
                      ) : (
                        <>
                          <img
                            src={Payment.prflag === "green" ? stupImg : stdwnImg}
                            alt=""
                            className="me-2"
                          />
                          {Payment.prpercent === "Infinity"
                            ? "100%"
                            : (isNaN(Payment.prpercent)
                              ? (0 + "%")
                              : Payment.prpercent + "%")}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main-green d-flex align-center text-bigger">
                          <img className="paymt-rec" src={greenImg} alt="" />
                          <button className="button-link link-color"
                            onClick={(e) =>
                              showInfo(e, "transactions", { data: 0 })
                            }
                          >

                            {Payment !== "" ? parseFloat(Payment.received).toFixed(2) : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>

                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={payRImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h ">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Payment Pending</h5>
                    <div className="d-flex align-items-center justify-content-center">
                      {Payment === "" ? (
                        <Skeleton className="w-30px" />
                      ) : (
                        <>
                          <img
                            src={Payment.peflag === "green" ? stupImg : stdwnImg}
                            alt="green"
                            className="me-2"
                          />
                          {Payment.pepercent === "Infinity"
                            ? "100%"
                            : isNaN(Payment.pepercent)
                              ? 0 + "%"
                              : Payment.pepercent + "%"}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main-red d-flex align-center text-bigger">
                          <img className="paymt-rec" src={redcImg} alt="" />
                          <button className="button-link link-color"
                            onClick={(e) =>
                              showInfo(e, "transactions", { data: 3 })
                            }
                          >
                            {Payment !== "" ? parseFloat(Payment.pending).toFixed(2) : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>

                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={payPImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Plan Renewals</h5>
                    {/* <div className="d-flex align-items-center justify-content-center">
                    {MemRenew === "" ? (
                      <Skeleton className="w-30px" />
                    ) : (
                      <>
                        <img
                          src={MemRenew.upflag === "green" ? stupImg : stdwnImg}
                          alt=""
                          className="me-2"
                        />
                        {MemRenew.percent === "Infinity"
                          ? "100%"
                          : isNaN(MemRenew.percent)
                            ? 0 + "%"
                            : MemRenew.percent + "%"}
                      </>
                    )}
                  </div> */}
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main text-bigger">
                          <button className="button-link link-color"
                            onClick={(e) => showInfo(e, "mmanager", { data: 6 })}
                          >
                            {MemRenew !== "" ? MemRenew.renewcount
                              : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>
                        <div className="card-text d-flex space-between">
                          <small>Extended </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) =>
                                showInfo(e, "mmanager", { data: 7 })
                              }
                            >
                              {MemRenew !== ""
                                ? MemRenew.extended
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between">
                          <small>Upgraded </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) =>
                                showInfo(e, "mmanager", { data: 8 })
                              }
                            >
                              {MemRenew !== ""
                                ? MemRenew.urenewcount
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between">
                          <small>Downgraded </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) =>
                                showInfo(e, "mmanager", { data: 9 })
                              }
                            >
                              {MemRenew !== ""
                                ? MemRenew.drenewcount
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={usrImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Today's Staff Attendance</h5>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main d-flex align-center text-bigger">
                          <button className="button-link link-color"
                            onClick={(e) => showInfo(e, "staff", { data: 0 })}
                          >
                            {StaffAtt !== ""
                              ? StaffAtt.count
                              : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>
                        <div className="card-text d-flex space-between">
                          <small>Present</small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => showInfo(e, "staff", { data: 1 })}
                            >
                              {StaffAtt !== ""
                                ? StaffAtt.present
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between clr-red">
                          <small className="">Absent </small>
                          <small className="">
                            <button className="button-link link-color"
                              onClick={(e) => showInfo(e, "staff", { data: 2 })}
                            >
                              {StaffAtt !== ""
                                ? StaffAtt.absent
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={usrImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title ">Overdue CheckIn(s)</h5>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main d-flex align-center text-bigger">
                          <button className="button-link link-color"
                            onClick={(e) => ViewOverdueHandler(e, "checkin", { data: 0 })}
                          >
                            {overDuecheckins !== ""
                              ? overDuecheckins?.todaycheckin
                              : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>
                        <div className="card-text d-flex space-between">
                          <small>Male </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => ViewOverdueHandler(e, "checkin", { data: 1 })}
                            >
                              {overDuecheckins !== ""
                                ? overDuecheckins?.mcount
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between">
                          <small>Female </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => ViewOverdueHandler(e, "checkin", { data: 2 })}
                            >
                              {overDuecheckins !== ""
                                ? overDuecheckins?.fcount
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={ucheckInImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>




            <div className="col-xl-3 col-sm-12 col-md-6 col-6">
              <div className="card mb-0 card-gym card-h">
                <div className=" g-0 ">
                  <div className="d-flex space-between p-15 col-lg-12">
                    <h5 className="card-title">No Recent Activity
                    </h5>
                  </div>
                  <div className="d-flex">
                    <div className="col-md-9 col-sm-9 w-50">
                      <div className="card-body card-body-dashb">
                        <h5 className="card-text clr-main d-flex align-center text-bigger">
                          <button className="button-link link-color"
                            onClick={(e) => ViewInactiveHandler(e, "checkin", { data: 0 })}
                          >
                            {inactiveMembers !== undefined
                              ? inactiveMembers?.membersinfo?.length || 0
                              : <Skeleton className="w-30px" /> || 0}
                          </button>
                        </h5>
                        <div className="card-text d-flex space-between">
                          <small>Male </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => ViewInactiveHandler(e, "checkin", { data: 1 })}
                            >
                              {inactiveMembers !== undefined
                                ? inactiveMembers?.membersinfo?.filter(m => m.sex !== "Female")?.length || 0
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                        <div className="card-text d-flex space-between">
                          <small>Female </small>
                          <small>
                            <button className="button-link link-color"
                              onClick={(e) => ViewInactiveHandler(e, "checkin", { data: 2 })}
                            >
                              {inactiveMembers !== undefined
                                ? inactiveMembers?.membersinfo?.filter(m => m.sex === "Female")?.length || 0
                                : <Skeleton className="w-30px" /> || 0}
                            </button>
                          </small>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-3 d-flex justify-end w-48">
                      <img
                        className="h-103"
                        src={usrImg}
                        alt="Trendy Pants and Shoes"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <MDBTabs className="py-3 pb-1 ">
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab1")}
                active={basicActive === "tab1"}
              >
                Expiring This Week
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleBasicClick("tab2")}
                active={basicActive === "tab2"}
              >
                Expired in last 30 days
              </MDBTabsLink>
            </MDBTabsItem>

          </MDBTabs>
          <MDBTabsContent className="h-auto">
            <MDBTabsPane show={basicActive === "tab1"} open={basicActive === "tab1"}>
              <div className="dashboardTable">
                <MDBDatatable
                  fixedHeader
                  maxHeight="500px"
                  data={mData}
                  defaultentries={5}
                />
              </div>
            </MDBTabsPane>
            <MDBTabsPane show={basicActive === "tab2"} open={basicActive === "tab2"}>
              <div className="dashboardTable">
                <MDBDatatable
                  fixedHeader
                  maxHeight="500px"
                  data={mOData}
                  defaultentries={5}
                />
              </div>
            </MDBTabsPane>
          </MDBTabsContent>
        </div>
      </div>}

      <MDBModal open={overduePopup} setOpen={setOverduePopup} tabIndex='-1'>
        <MDBModalDialog size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Overdue CheckIn(s)</MDBModalTitle>
              <MDBBtn className='btn-close' color='none'
                onClick={() => { setOverduePopup(false); setOverdueFilter({}) }}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MDBDatatable entries={25} data={basicData} className="SuscriptionHistoryDataTable" />
            </MDBModalBody>
            <MDBModalFooter className="pb-2 pe-3">

              <MDBBtn className="ms-2" onClick={() => downloaddata(basicData, "OverDue Check-Ins")}>download</MDBBtn>
              <MDBBtn color='secondary'
                onClick={() => { setOverduePopup(false); setOverdueFilter({}) }}
              >
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>

      </MDBModal>


      <MDBModal open={inactivePopup} setOpen={setInactivePopup} tabIndex='-1'>
        <MDBModalDialog size="xl" scrollable>
          <MDBModalContent>
            <MDBModalHeader className="border-bottom">
              <MDBModalTitle className="d-flex align-items-center gap-2">
                <i className="fas fa-user-clock text-warning"></i>
                Active Members Not Checked In for the Past {inactiveDaysFilter} Days
                <span className="badge bg-primary ms-2">{inactiveMemberinfo?.length || 0} members</span>
              </MDBModalTitle>
              <MDBBtn
                className='btn-close'
                color='none'
                onClick={() => {
                  setInactivePopup(false);
                  setInactiveFilter({});
                }}
              />
            </MDBModalHeader>
            <MDBModalBody>
              {/* Modern Filter Card */}
              <div className="card shadow-0 mb-0">
                <div className="card-body p-0">
                  <div className="row align-items-center g-3 mb-2">
                    {/* Filter Label */}
                    <div className="col-12 col-md-auto m-0">
                      <label className="fw-bold mb-0">
                        <i className="fas fa-filter me-2"></i>
                        Filter by inactive days:
                      </label>
                    </div>

                    {/* Quick Filter Buttons */}
                    <div className="col-12 col-md-auto m-0">
                      <div className="btn-group btn-group-sm shadow-sm" role="group">
                        {[10, 15, 20, 30].map((days) => (
                          <button
                            key={days}
                            type="button"
                            className={`btn ${inactiveDaysFilter === days ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => handleInactiveDaysChange(days)}
                            disabled={inactiveLoading}
                          >
                            {days}days
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Custom Input with Icon */}
                    <div className="col-12 col-md-auto m-0">
                      <label className="fw-bold mb-0">

                        Select custom days:
                      </label>
                    </div>
                    <div className="col-12 col-md-auto m-0">
                      <div className="input-group input-group-sm shadow-sm" style={{ maxWidth: '180px' }}>
                        <span className="input-group-text bg-light square border-end border-warning">
                          <i className="fas fa-calendar-alt text-muted"></i>
                        </span>
                        <input
                          type="number"
                          className="form-control square border border-warning"
                          placeholder="Custom days"
                          min="1"
                          max="1825"
                          value={inactiveDaysFilter}
                          disabled={inactiveLoading}

                          onChange={(e) => {
                            const value = e.target.value;

                            // allow empty input (for smooth delete)
                            if (value === "") {
                              setInactiveDaysFilter("");
                              return;
                            }

                            // allow only valid numbers
                            const num = Number(value);
                            if (num >= 1 && num <= 1825) {
                              setInactiveDaysFilter(value);
                            }
                          }}

                          onBlur={() => {
                            // default value if empty
                            const finalValue = inactiveDaysFilter === "" ? 10 : Number(inactiveDaysFilter);
                            setInactiveDaysFilter(String(finalValue));
                            handleInactiveDaysChange(finalValue);
                          }}

                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              const finalValue = inactiveDaysFilter === "" ? 10 : Number(inactiveDaysFilter);
                              setInactiveDaysFilter(String(finalValue));
                              handleInactiveDaysChange(finalValue);
                            }
                          }}
                        />




                        <button className="input-group-text bg-light text-muted square border-start border-warning">Apply</button>
                      </div>
                    </div>

                    {/* Loading Indicator */}
                    {inactiveLoading && (
                      <div className="col-auto">
                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>


              {/* Data Table with Loading Overlay */}
              <div className="position-relative">
                {inactiveLoading && (
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75"
                    style={{ zIndex: 10 }}
                  >
                    <div className="text-center">
                      <div className="spinner-border text-primary mb-2" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="text-muted mb-0">Loading members...</p>
                    </div>
                  </div>
                )}
                <MDBDatatable
                  entries={25}
                  data={inactiveBasicData}
                  className="SuscriptionHistoryDataTable"
                />
              </div>

              {/* Empty State */}
              {!inactiveLoading && inactiveMemberinfo.length === 0 && (
                <div className="text-center py-5">
                  <i className="fas fa-check-circle fa-4x text-success mb-3"></i>
                  <h5 className="text-muted">Great! No inactive members found</h5>
                  <p className="text-muted mb-0">
                    All active members have visited in the last {inactiveDaysFilter} days
                  </p>
                </div>
              )}
            </MDBModalBody>
            <MDBModalFooter className="border-top">
              <div className="d-flex gap-2">
                <MDBBtn
                  color="success"
                  size="sm"
                  disabled={inactiveLoading || inactiveMemberinfo.length === 0}
                  onClick={() => downloaddata(inactiveBasicData, `Inactive Active Members (Last ${inactiveDaysFilter} Days)`)}
                >
                  <i className="fas fa-download me-2"></i>
                  Download
                </MDBBtn>
                <MDBBtn
                  color='secondary'
                  size="sm"
                  onClick={() => {
                    setInactivePopup(false);
                    setInactiveFilter({});
                  }}
                >
                  <i className="fas fa-times me-2"></i>
                  Close
                </MDBBtn>
              </div>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}